<template>
    <main id="home-wrapper">
        <div id="faq">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url+'/', status: false },
                    { title: 'FAQ', url: app_url+'/faq', status: true }
                ]"
            ></breadcrumb>


            <section id="headline-paguyuban" class="section withPad blackBg">
                <div class="container">
                    <div class="head-title">
                        <h3>FAQ</h3>
                    </div>
                </div>
            </section>

            <section id="faq-section" class="section withPad">
                <div class="container">
                    <div class="list-faq">
                        <div id="tnc-accodion" v-if="faq && faq.length > 0">
                          <div class="items" v-for="(data, index) in faq" :key="index" :ref="'items'+index" @click="toggleAccordion('items'+index, data)">
                            <h4 class="page">{{ data.question }}</h4>
                            <div class="content" v-html="data.answer">
                            </div>
                          </div>
                        </div>
                    </div>

                    <div class="row_flex_black">
                        <p>Ada Pertanyaan ? Kunjungi Help Center</p>

                        <div class="right-button">
                            <div class="cta-product-box black_submit">
                            <a v-if="help_url" @click="gtmPanelTracking('Kunjungi Help Center', help_url, 'Community FAQ')" :href="help_url" class="tx-white">Help Center</a>
                            <a v-else @click="gtmPanelTracking('Kunjungi Help Center', help_url, 'Community FAQ')" href="mailto:info@hondacommunity.net" class="tx-white">Help Center</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </main>
</template>

<script>
import BreadCrumb from "../../widget/BreadCrumb";
import { isMobile } from "mobile-device-detect";
import $ from 'jquery';

export default {
    components: {
        breadcrumb: BreadCrumb
    },
    data() {
        return {
            base_url:base_url,
            app_url:app_url,
            api_url:api_url,
            help_url:null,
            mobile: false,
            faq: [],
        };
    },
    created() {
        this.mobile = isMobile;
        this.help_url = help_faq_url;
        this.getFaq();
    },
    methods: {
        seeMoreTracker(data) {
            const track = {
                'event': 'seeMore',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action': 'See More Detail',
                'eventDetail.label': window.location.href,
                'list': data.question ?? '',
            }
            dataLayer.push(track);
        },
      getFaq() {
          axios
              .get(api_url+"/faq/2")
              .then(res => {
                  console.log(res);
                  this.faq = res.data.data;
                //   if (res.status == 200) {
                //       if (res?.data?.status) {
                //           this.faq.push(
                //               ...res?.data?.data?.faq
                //           );
                //       }
                //   }
              })
              .catch(err => {
                  console.log(err);
              });
      },
      toggleAccordion(element, data){
        this.seeMoreTracker(data)
        let el = this.$refs[element];
        let page = el[0].children[0];
        if(page.classList.value.includes("active")){
          page.classList.remove('active');
        }else{
          page.classList.add('active');
        }
        let content = el[0].children[1];
        if(content.classList.value.includes("active")){
          content.classList.remove('active');
        }else{
          content.classList.add('active');
        }
      },
      gtmPanelTracking(action, destinationPageUrl, destinationPageTitle) {
        var dataTracker = {
            'event': 'panelTracking',
            'eventDetail.category': 'Panel Tracking',
            'eventDetail.action': action,
            'eventDetail.label': window.location.href,
            'sourcePageTitle': 'FAQ',
            'destinationPageUrl': destinationPageUrl,
            'destinationPageTitle': destinationPageTitle,
        }
        dataLayer.push(dataTracker);
      }
    },
    mounted() {
        $.fn.accordion_tnc = function () {
            $(".page").click(function (e) {
              console.log(e)
                if (!$(this).is('.active')) {
                    $(".page,.content").removeClass('active');
                    $(".page").siblings('.content:visible').slideUp("slow");
                    $(this).addClass('active');
                    $(this).siblings('.content').slideDown("slow");
                    $(this).siblings('.content').addClass("active");
                } else {
                    $(this).removeClass('active');
                    $(this).siblings('.content').slideUp("slow");
                }
            });
        }
        $("#tnc-accodion").accordion_tnc();
    }
};
</script>

<style scoped lang="scss">
#faq{
  .items{
    .active{
      display: block;
    }
  }
}
.img-promo-section-event {
    border-radius: 0px;
    float:right;
    overflow: hidden;
    img {
        max-width: 100%;
    }
}

.content-promo-section {
    padding-right: 120px;
    padding-left: 40px;
}
.wrap-label {
    justify-content: start;
}
.wrap-label span {
    font-size: 12px;
    font-weight: 500;
    display: inline-block;
    margin-right: 10px;
}
.date-news span,
.date-news p {
    display: inline-block;
}
.date-news span {
    font-size: 15px;
    margin-right: 5px;
}
.title-promo {
    margin-bottom: 20px;
    h2 {
        margin-top: 0;
        color: #fff;
        margin-bottom: 20px;
    }
    p {
        margin: 0;
        line-height: 24px;
        color: #8e8e8e;
    }
}
.btn-share {
    position: relative;
}
.btn-share a {
    margin-top: 0;
    border-radius: 100px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    width: 35px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    color: #fff;
    background-color: transparent;
}
.btn-share a:hover {
    background-color: #e61b33;
    color: #fff;
}
.active .shares {
    width: 150px;
    left: 42px;
}
.active .shares {
    width: 150px;
}
.active .sharebtn {
    color: #999;
    background-color: #f2f2f2;
}
.shares {
    position: absolute;
    bottom: 0;
    left: 35px;
    height: 35px;
    width: 0;
    overflow: hidden;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    a {
        margin: 0 4px;
    }
}
.offset-section {
    padding-left: 7em;
}
.group_icon_detail .wrap-label{
    margin-bottom:-15px;

}
#headline-events .col-grid-50.flex_align_center{
  display:flex;
  flex:1;
  align-items:center;
}
#row-middle-events{
    padding-top:20px;
    padding-bottom:20px;
    border-top:1px solid rgba(219,219,219,0.1);
    border-bottom:1px solid rgba(219,219,219,0.1);
}
.row_flex_black{
    display:flex;
    align-items:center;
    justify-content: space-between;
    background: rgba(255, 255, 255, 0.02);
    box-shadow: 8px 4px 25px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding:20px;
    margin:30px 0;
}
.row_flex_black p{
    font-weight: 600;
    font-size: 14px;
    color: #FFFFFF;
}
.row_flex_black .cta-product-box a{
    background:#282828;
    border:1px solid #282828;
    padding:5px 15px

}
#faq-section{
    background: #000;
}
   #faq-section .items iframe,iframe{
      width: 100% !important;
  }
@media (max-width: 768px) {
  .row_flex_black{
    display: block;
  }

   #faq .items iframe,iframe{
      width: 100% !important;
  }
}
</style>
